import axios, {Axios} from "axios"
import {NAME_SERVER} from "../Utils/NAME_HOST";
export const API_URL = NAME_SERVER+"/api"

const $api = axios.create({
    withCredentials: true,// куки цепляются автоматический
    baseURL:API_URL
})
$api.interceptors.request.use(((config)=>{
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`
    return config;
}) , (error)=>{
    console.err("Ошибка")
})
$api.interceptors.response.use((config=>{
    return config
}) , async(error)=>{
    const originalRequest =error.config;
    if (error.response.status === 401 && error.config && !error._isRetry){
        originalRequest._isRetry = true;
        try{
            const response = await $api.get(`${API_URL}/refresh` , {withCredentials:true})
            localStorage.setItem("token" , response.data.accessToken);
            return $api.request(originalRequest);
        }
        catch (e){
            console.log("Не авторизован 401")
        }

    }
    else{
        throw error;
    }
})
export default $api